export const ProductPhotos =[
    
        {imgUrl:"../pi/l/Product/p (3).jpg"},
{imgUrl:"../pi/l/Product/p (2).jpg"},
{imgUrl:"../pi/l/Product/p (3).jpg"},
{imgUrl:"../pi/p/Product/p (6).jpg"},
{imgUrl:"../pi/l/Product/p (5).jpg"},
{imgUrl:"../pi/p/Product/p (7).jpg"},
{imgUrl:"../pi/p/Product/p (2).jpg"},
{imgUrl:"../pi/p/Product/p (4).jpg"},
{imgUrl:"../pi/l/Product/p (4).jpg"},
{imgUrl:"../pi/p/Product/p (1).jpg"},
{imgUrl:"../pi/p/Product/p (5).jpg"},
{imgUrl:"../pi/l/Product/p (1).jpg"},
    
    ]